// default to 8km, ~5mi radius
export default 8000;
